import useError from './use-error';

export { useError };

export default useError;
